module.exports = __webpack_public_path__ + "media/images/shared/icon-payment-white-3315e531139575abd4e73f7f61933e41.png";